var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardInpatientsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 27.3335L43.3334 31.3335M43.3334 31.3335L47.3334 27.3335M43.3334 31.3335V23.3335M39.3334 46.0002V44.4002C39.3334 42.16 39.3334 41.0398 38.8974 40.1842C38.5139 39.4316 37.902 38.8196 37.1494 38.4361C36.2937 38.0002 35.1736 38.0002 32.9334 38.0002H27.0667C24.8265 38.0002 23.7064 38.0002 22.8508 38.4361C22.0981 38.8196 21.4862 39.4316 21.1027 40.1842C20.6667 41.0398 20.6667 42.16 20.6667 44.4002V46.0002M34.6667 28.0002C34.6667 30.5775 32.5774 32.6668 30.0001 32.6668C27.4228 32.6668 25.3334 30.5775 25.3334 28.0002C25.3334 25.4228 27.4228 23.3335 30.0001 23.3335C32.5774 23.3335 34.6667 25.4228 34.6667 28.0002Z",
    stroke: "#6941C6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardInpatientsActive);
export default __webpack_public_path__ + "static/media/card-inpatients-active.56bdbe8b41c04f5a05340a9b2442ccae.svg";
export { ForwardRef as ReactComponent };